import { RoutePermissionSetting } from "@sal/onevent-portal";
import { type Settings as PortalFrameworkSettings } from "@sal/portal";

type LayoutSettings = {
	Orientation?: "Vertical" | "Horizontal";
};

type AppSettings = {
	Layout?: LayoutSettings;
	PortalFramework: PortalFrameworkSettings;
};

const AppSettings: AppSettings = {
	Layout: {
		Orientation: "Vertical"
	},
	PortalFramework: {
		logoUrl: "/images/move_logo.svg",
		loginTitle: "Log into your account",
		defaultColorMode: "system"
	}
} as const;

export default AppSettings;

export const routePermissionMapping: { [key: string]: RoutePermissionSetting } = {
	containerTransportDashboard: {
		path: "/Dashboard",
		securityContext: "apI_ContainerTransportImportFCLOrder",
		securityContextPermission: "Read" //TODO: Update with correct security context and permission
	},
	users: {
		path: "/Users",
		securityContext: "portal_Users",
		securityContextPermission: "Read"
	},
	importFCLTransportOrder: {
		path: "/ImportFCLTransportOrder",
		securityContext: "apI_ContainerTransportImportFCLOrder",
		securityContextPermission: "Read"
	},
	exportFCLTransportOrder: {
		path: "/ExportFCLTransportOrder",
		securityContext: "apI_ContainerTransportExportFCLOrder",
		securityContextPermission: "Read"
	},
	importFAKTransportOrder: {
		path: "/ImportFAKTransportOrder",
		securityContext: "apI_ContainerTransportImportFAKOrder",
		securityContextPermission: "Read"
	},
	exportFAKTransportOrder: {
		path: "/ExportFAKTransportOrder",
		securityContext: "apI_ContainerTransportExportFAKOrder",
		securityContextPermission: "Read"
	},
	importContainer: {
		path: "/ImportContainer",
		securityContext: "apI_ContainerTransportImportContainer",
		securityContextPermission: "Read"
	},
	exportContainer: {
		path: "/ExportContainer",
		securityContext: "apI_ContainerTransportExportContainer",
		securityContextPermission: "Read"
	},
	order: {
		path: "/Order",
		permissions: [
			["apI_ContainerTransportImportFCLOrder", "Write"],
			["apI_ContainerTransportImportFAKOrder", "Write"],
			["apI_ContainerTransportExportFCLOrder", "Write"],
			["apI_ContainerTransportExportFAKOrder", "Write"],
			["apI_ContainerTransportGeneralFreightOrder", "Write"]
		]
	},
	customers: {
		path: "/Customers",
		securityContext: "portal_Contact",
		securityContextPermission: "Web_Customers_Read"
	},
	locations: {
		path: "/Locations",
		securityContext: "portal_Menu",
		securityContextPermission: "Web_Locations"
	},
	generalFreightOrder: {
		path: "/GeneralFreightOrder",
		securityContext: "apI_ContainerTransportGeneralFreightOrder",
		securityContextPermission: "Read"
	}
};

// This configure setting control the basic setting of preference form
export const preferenceFormConfigSetting = {
	Currency: { hided: true },
	Home: { hided: true },
	Timezone: { hided: true },
	Distance: { hided: true },
	Weight: { hided: true },
	Size: { hided: true },
	DateFormat: { hided: false, required: false }
};

export const googleMapsLibraries = ["core", "geometry", "maps", "marker", "places"] as const;
